export const formatLlmDuration = (durationMs?: number | null) => {
  if (typeof durationMs !== 'number' || !Number.isFinite(durationMs)) {
    return '-';
  }

  if (durationMs < 1000) {
    return `${durationMs.toLocaleString()} ms`;
  }

  return `${(durationMs / 1000).toLocaleString(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  })} s`;
};
